<template>
  <div class="page-container">
    <ul class="list-box">
      <li class="item-box" v-for="(item, outerIndex) in list" :key="outerIndex">
        <p class="title">{{item.title}}</p>
        <div class="render-box" v-if="item.value">
          <div class="item-row" v-for="(v, k, index) in item.value" :key="index">
            <div class="row-left" v-if="item.left">
              <span
                v-for="(innerItem, index) in Array.prototype.slice.call(k)"
                :key="index"
              >{{innerItem}}</span>
            </div>
            <div class="row-right">{{item.left ? ':': '' }} {{v}}</div>
          </div>
        </div>
        <div class="render-image" v-else>
          <van-image
            v-touch:tap="lookBigImage(item.image)"
            class="image"
            lazy-load
            fit="cover"
            :src="item.image"
          />

          <div class="addres" v-if="item.addres">
            <div>地址：中国海南省海口市琼山区国兴大道68号</div>
            <div>邮编：570203</div>
            <div>停车信息：免费室外停车场</div>
            <div>交通信息：在市区乘坐12路、27路、33路、43路、 51路、52路、56路、67路、68路、游4、游5公交 车到海南广场下车</div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      list: [
        {
          title: "联系我们",
          left: true,
          value: {
            服务中心: "0898-65238891",
            办公室电话: "0898-65238880",
            传真: "0898-65238880",
            邮箱: "hnbwg@vip.163.com",
          },
        },
        {
          title: "交通服务",
          image: require("@image/personalCenter/123.jpg"),
          addres: true,
        },
        {
          title: "开放时间",
          left: true,
          value: {
            周一: "闭馆整休",
            周二至周日: "09:00(开馆) - 16:30(停止检票) - 17:00(闭馆",
          },
        },
        {
          title: "海南省博物馆总平面图",
          image: require("@image/personalCenter/321.png"),
        },
        {
          title: "参观须知",
          left: false,
          value: [
            "1、开放时间：每周二至周日9:00-17:00（16:30停止预约当日参观及停止入馆），周一闭馆（逢节假日正常开馆）。",
            "Open time: 9:00-17:00(no admission at 16:30); closed on Monday(open normally on holidays).",
            "2、实行网络实名制预约入馆，每天限额8000人，额满为止。个人或家庭可提前7日（含当天）预约，团队、企事业、学校可提前7日（不含当天）预约。年龄满60岁以上老年人和未成年观众可凭老年卡、户口本等有效证件取票，或至人工窗口登记取票入馆。",
            "Hainan Museum implement the online real-name system to make an appointment, with a daily limit of 8,000 people until the quota is full. Individuals or families can make an appointment 7 days in advance (including the day), and teams, enterprises and schools can make an appointment 7 days in advance (excluding the day). Older people over the age of 60 and underage viewers can use valid certificates such as older-age cards, household registration books to collect ticket at ticket office.",
            "3、衣冠不整、举止不雅及醉酒者谢绝入馆，携带危险管制物品者、携带宠物者（导盲犬除外）谢绝入馆。",
            "Hainan museum excludes anyone who is disheveled or bad mannered, and anyone carrying dangerous controlled articles or pets (except guide dogs) from entering.",
            "4、学龄前儿童、高龄老人、行动不便者须有成年人陪护入馆参观。",
            "Preschoolers, oldest-old, and disabled people must be accompanied by adults.",
            "5、展厅内禁止使用闪光灯拍照、饮食、喧哗、嬉闹，禁止从事其它与参观无关的事情；禁止随地吐痰、吸烟和随手乱扔废弃物等不文明行为，自觉接受管理人员的引导。",
            "No flash photography, eating, frolic, shouting, and other things unrelated to the visit in the exhibition halls. Please consciously accept the guide of the management personnel.",
            "6、请勿在馆内使用旱冰鞋、滑板、儿童电动车、儿童自行车等休闲娱乐用品。",
            "Do not use roller skates, skateboards, children's electric car, children's bicycles, and other recreational products in the museum.",
            "7、参观车辆在停车场指定位置有序停放，请勿在禁停区停放。",
            "Vehicles should be parked orderly in the designated place of the parking lot. Do not park in the no-parking area.",
            "8、爱护文物展品、展览设施和其它公共服务设施及花草树木、绿地等，如有损坏照价赔偿或承担相应法律责任。",
            "Please protect the cultural relics, exhibition facilities, and other public facilities as well as flowers, trees, and green space, etc. Any damages should be paid in full of the price, and the corresponding legal liability should be assumed.",
          ],
        },
      ],
    };
  },

  methods: {
    lookBigImage(img) {
      return () => {
        ImagePreview({
          images: [img],
          closeable: true,
        });
      };
    },
  },

  // components: {
  //     [ImagePreview.Component.name]: ImagePreview.Component,
  // },
};
</script>

<style lang="less" scoped>
.page-container {
  padding: 10px;
  background-color: #fff !important;
  .image {
    width: 100%;
    display: block;
  }
  .list-box {
    .item-box {
      .title {
        text-align: center;
        color: #2d537a;
        font-size: 20px;
        font-weight: 500;
        margin: 10px 0px;
        position: relative;
        &::before,
        &::after {
          content: " ";
          flex: 1;
          height: 1.5px;
          background-color: #2d537a;
          display: inline-block;
          vertical-align: super;
          width: 20px;
          margin: 0 15px;
          border-radius: 3px;
        }
      }
      .addres {
        margin-top: 10px;
      }
      .render-box {
        .item-row {
          margin-bottom: 5px;
          display: flex;
          // justify-content: space-between;
          align-items: flex-start;
          &:last-of-type {
            margin-bottom: 0;
          }
          .row-left {
            width: 90px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-right: 8px;
          }
          .row-right {
            flex: 1;
          }
        }
      }
    }
  }
}
</style>